import { IS_OFFLINE } from "@/services/http";

/**
 * Shown only while the app has no API configured and is rendering demo data
 * from `src/mocks`. It disappears automatically once VITE_PUBLIC_API_URL is set,
 * so a real deployment can never silently look "live" while serving samples.
 */
export default function DemoModeBanner() {
  if (!IS_OFFLINE) return null;

  return (
    <div className="w-full border-b border-secondary-200 bg-secondary-50 px-4 py-2 md:px-6">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-xs font-medium text-secondary-900">
        <i className="ri-flask-line text-sm text-secondary-600"></i>
        <span>Demo mode — this site is showing sample data.</span>
        <span className="text-secondary-700">
          Add your API URL to publish with live listings.
        </span>
      </div>
    </div>
  );
}